import { v4 as uuidv4 } from "uuid";
import checkBulletImage from "@circle-react-shared/BuilderUI/Assets/icons/check_bullet.png";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createCardBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/layoutBlockHelpers";
import {
  createBadgeBlock,
  createButtonBlock,
  createH2Block,
  createH5Block,
  createPBlock,
  createUlBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getMarginOptions } from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getTextAlignOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { getBlockPrimaryStyleOptions } from "../../constants";

const cards = [
  {
    highlight: "",
    header: "Essentials",
    price: "$3,987",
    badge: "One Time Investment",
    description:
      "A streamlined option for independent professionals who prefer structured support.",
    featuresTitle: "Includes:",
    features: [
      "12 weekly group strategy calls",
      "Full curriculum library",
      "Community membership access",
      "Foundational email support",
      "Progress tracking system",
    ],
    buttonText: "Apply now",
    buttonHref: "#",
    buttonVariant: "secondary",
    footer: "",
  },
  {
    highlight: "MOST POPULAR",
    header: "Breakthrough",
    price: "$3,987",
    badge: "One Time Investment",
    description:
      "Designed for professionals ready to accelerate with personalized coaching and planning.",
    featuresTitle: "Includes:",
    features: [
      "12 private 1:1 coaching sessions",
      "Strategic planning intensive",
      "Full curriculum library",
      "Community membership access",
      "Between-session advisor support",
      "Templates, tools & frameworks",
      "Lifetime platform access",
    ],
    buttonText: "Apply now (Limited spots)",
    buttonHref: "#",
    buttonVariant: "primary",
    footer: "Only 3 spots remaining this month",
  },
  {
    highlight: "",
    header: "VIP Experience",
    price: "$12,987",
    badge: "One Time Investment",
    description:
      "An elite tier for executives and leaders seeking high-touch, high-impact growth.",
    featuresTitle: "Includes:",
    features: [
      "All breakthrough benefits",
      "6-month extended engagement",
      "2 private VIP strategy days",
      "24/7 advisor access",
      "Custom systems & resources",
      "Executive peer roundtables",
      "Quarterly strategic reviews",
    ],
    buttonText: "Apply now",
    buttonHref: "#",
    buttonVariant: "secondary",
    footer: "",
  },
];

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "ProfessionalNetworkHomepageBlock8",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Choose your professional growth path",
        }),
        createPBlock({
          text: "Whether you're building momentum or scaling big, select the plan that fits your goals and pace.",
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: cards.map(
        ({
          highlight,
          header,
          price,
          badge,
          description,
          featuresTitle,
          features,
          buttonText,
          buttonHref,
          buttonVariant,
          footer,
        }) =>
          createCardBlock({
            highlight,
            value: [
              createH5Block({ text: header }),
              createH2Block({
                text: price,
              }),
              createBadgeBlock({ text: badge }),
              createPBlock({
                text: description,
                paragraphStyle: "p3",
              }),
              createPBlock({
                text: featuresTitle,
                paragraphStyle: "p3",
              }),
              createUlBlock({
                items: features.map(feature => ({
                  text: feature,
                  placeholder: checkBulletImage,
                })),
              }),
              createButtonBlock({
                text: buttonText,
                href: buttonHref,
                buttonType:
                  buttonVariant === "primary"
                    ? "primaryButton"
                    : "secondaryButton",
                styles: {
                  margin: getMarginOptions({
                    defaultValue: {
                      marginTop: "30",
                      marginBottom: "0",
                      marginLeft: "0",
                      marginRight: "0",
                    },
                  }),
                },
              }),
              createPBlock({
                text: footer,
                paragraphStyle: "p3",
                styles: {
                  textAlign: getTextAlignOptions("center"),
                },
              }),
            ],
          }),
      ),
    },
    footer: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "Payment plans available. Schedule a free consultation to discuss options.",
          paragraphStyle: "p3",
        }),
        createButtonBlock({
          text: "Book Your Free Strategy Call",
          href: "#",
          buttonType: "primaryButton",
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getBlockPrimaryStyleOptions(),
      },
    },
  },
};
